"use client"
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import Layout from "./Layout";
import AuthHead from "./authhead";
import {
  BtnInput,
  CheckInput,
  DontHave,
  EmailInput,
  PasswordInput,
} from "./inputs";
import { useChangeAuthType } from "@/util/hooks/changeAuth";
//import { useRouter } from "next/navigation";
//import { AppLinks } from "@/util/data/navigation";
import { useFormik } from 'formik';
import { AppLinks, appResponse, IAppStore, Iuser, IUserLogin, StorageKey } from "@/util";
import { LoginSchema } from "@/util/validationSchema/auth";
import { useMutation } from "@tanstack/react-query";
import { userLoginApi, userMeApi } from "@/util/api/user";
import { AxiosError } from "axios";
import useToastAlert from "@/util/hooks/usesnackbar";
import AppStorage from "@/util/services/storage";
import {useDispatch, useSelector} from 'react-redux'
import { ADD_USER } from "@/store/user";
import { useRouter } from "next/navigation";
import Loader from "@/app/loading";
export default function Login() {
  const { classes } = styles();
  const changeAuthType = useChangeAuthType();
  const router = useRouter();
  const dispatch = useDispatch();
  const[check,setCheck]=React.useState<boolean>(true);
 const toastAlert=useToastAlert();
  const loginData:Partial<IUserLogin>={
    username:"",
    password:""
 }
  const userLoginFormik=useFormik({
    initialValues:loginData,
    validateOnChange:false,
    validateOnBlur:false,
    validateOnMount:false,
    validationSchema:LoginSchema,
    onSubmit:(values)=>{

     handleUserLogin({username:values.username||"",password:values.password||""});
    }
  });

  const user=useSelector((app:IAppStore)=>app.user);
  useEffect(()=>{
  
    if(user.userId){
      USERME.mutate();
    }
  },[user,router]);
  


  const USERLOGIN = useMutation<appResponse<Iuser>, AxiosError, Partial<IUserLogin>>({
    mutationFn: userLoginApi,
    onSuccess: (data) => {
      const{accessToken,...payload}=data.payload
      dispatch(ADD_USER({accessToken,data:payload,isRemeber:check}));
      toastAlert({ message: data.message||"", type: 'success' });
    },
    onError: (error) => {
      toastAlert({ message: error.message, type: 'error' });
    },
  });

    const USERME = useMutation<appResponse<Iuser>, AxiosError>({
    mutationFn: userMeApi,
    onSuccess: (data) => {
      toastAlert({ message: data.message||"", type: 'success' });
      router.push(AppLinks.DASHBOARD.DASHBOARD);
    },
    onError: (error) => {
      toastAlert({ message: error.message, type: 'error' });
    },
  });
  

   const handleUserLogin=async(data:IUserLogin)=>{
     USERLOGIN.mutate({username:data.username,password:data.password});
   }
   const handleCheck=(e:boolean)=>{
     setCheck(e);
     AppStorage.saveItem(StorageKey.RememberUser,e);
   }

   React.useEffect(() => {
    // prefetch app link to be faster
    router.prefetch(AppLinks.DASHBOARD.DASHBOARD);
    const loadRememberUser = async () => {
    const defaultCheck = await AppStorage.getItem(StorageKey.RememberUser);
    setCheck(defaultCheck as boolean); // Cast to boolean if stored as string
    };
    loadRememberUser();
  }, [router, ]);

  return (
    <Layout image="/images/explore/explore.svg">
      {(USERME.isPending||USERLOGIN.isPending)&&<Loader imageType="bar"/>}
      <Box className={`${classes.container}`}>
        <AuthHead />
        <Box className={classes.input}>
          <EmailInput error={!!userLoginFormik.errors.username} value={userLoginFormik.values.username} handleChange={(e)=>userLoginFormik.setFieldValue('username',e)}/>
          <PasswordInput value={userLoginFormik.values.password} handleChange={(e)=>userLoginFormik.setFieldValue('password',e)} />
          <CheckInput value={check} handleChange={(e)=>handleCheck(e)} btnAction={() => changeAuthType("forgotpassword")} />
          <BtnInput
            name="Sign In"
            btnAction={() =>userLoginFormik.submitForm()}
          />
          <DontHave btnAction={() => changeAuthType("register")} />
        </Box>
      </Box>
    </Layout>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    backgroundColor: theme.colors.white,
    display: "flex",
    flexDirection: "column",
    width: "80%",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
}));
